import { TContainerVariant } from './types'

type ContainerVariantType = Required<
  Record<keyof typeof TContainerVariant, string>
>
export const VariantClasses: ContainerVariantType = {
  [TContainerVariant.normal]: 'max-w-screen-xl',
  [TContainerVariant.small]: 'max-w-screen-sm box-content',
}
